import axios from "axios";

// const BaseUrl = "http://localhost:5122/api/";
const BaseUrl = "https://gym25be.gunvortech.com/api/";

export const endpoints = {
  User: "User",
  Auth: "Auth",
  Org: "Org",
  Branch: "Branch",
  City: "City",
  SubsType: "SubsType",
  SubsPlan: "SubsPlan",
  InqSrc: "InqSrc",
  Inquiry: "Inquiry",
  FollowUpType: "FollowUpType",
  FollowUp: "FollowUp",
  Member: "Member",
  MemberStatus: "MemberStatus",
  Freeze: "Freeze",
  Invoice: "Invoice",
  Payment: "Payment",
  Meas: "Meas",
  Attend: "Attend",
  Notif: "Notif",
};

export const actions = {
  GetAll: "/GetAll",
  GetById: "/GetById",
  Post: "/Post",
  Put: "/Put",
  Delete: "/Delete",
  GetAuthUser: "/GetAuthUser",
  Login: "/Login",
  Logout: "/Logout",
  Forgot: "/Forgot",
  ChgPass: "/ChgPass",
  GetAllByBranch: "/GetAllByBranch",
  GetAllByOrg: "/GetAllByOrg",

  GetAllByMember: "/GetAllByMember",
  GetByMember: "/GetByMember",
  Unfreeze: "/Unfreeze",
  GetAllByType: "/GetAllByType",
  SetDefBranch: "/SetDefBranch",
  ChangeAccStatus: "/ChangeAccStatus",
  GetAuthUserBranches: "/GetAuthUserBranches",
  GetAuthUserOrg: "/GetAuthUserOrg",
  MarkeMakeMember: "/MarkeMakeMember",
};

export const API = (endpoint) => {
  const url = BaseUrl + endpoint + "/";
  const get = (onComplete) =>
    axios
      .get(url, { withCredentials: true })
      .then((res) => onComplete && onComplete(res.data))
      .catch((err) => {
        onComplete && onComplete(undefined, err);
        console.error("Error: ", err);
      });

  const getById = (id, onComplete) =>
    axios
      .get(url + id, { withCredentials: true })
      .then((res) => onComplete && onComplete(res.data))
      .catch((err) => {
        onComplete && onComplete(undefined, err);
        console.error("Error: ", err);
      });

  const post = (data, onComplete) =>
    axios
      .post(url, data, { withCredentials: true })
      .then((res) => onComplete && onComplete(res.data))
      .catch((err) => {
        onComplete && onComplete(undefined, err);
        console.error("Error: ", err);
      });

  const put = (data, onComplete) =>
    axios
      .put(url, data, { withCredentials: true })
      .then((res) => onComplete && onComplete(res.data))
      .catch((err) => {
        onComplete && onComplete(undefined, err);
        console.error("Error: ", err);
      });

  const Delete = (id, onComplete) =>
    axios
      .delete(url + id, { withCredentials: true })
      .then((res) => onComplete && onComplete(res.data))
      .catch((err) => {
        onComplete && onComplete(undefined, err);
        console.error("Error: ", err);
      });
  return {
    get,
    getById,
    post,
    put,
    Delete,
  };
};
